// Signal bars in PriorityGlyphs' 12x12 stroke style; unlit bars stay faint so every level is the same width.
const BARS = ['M2.5 10 L2.5 7.5', 'M6 10 L6 5', 'M9.5 10 L9.5 2.5'] as const;
const UNLIT_OPACITY = 0.3;

interface FrustrationGlyphProps {
    // How many bars are lit: 0 for not set, then low, medium, high.
    lit: 0 | 1 | 2 | 3;
    className?: string;
}

export function FrustrationGlyph({ lit, className }: FrustrationGlyphProps) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            {BARS.map((d, i) => (
                <path
                    key={d}
                    d={d}
                    stroke="currentColor"
                    strokeOpacity={i < lit ? 1 : UNLIT_OPACITY}
                />
            ))}
        </svg>
    );
}
